import React from 'react';

import SendEmailMessageActionSection from './SendEmailMessageActionSection';
import SleepSection from './Sleep';
import { useWorkflowStepType } from './useWorkflowStepField';

type Props = {
  name: string;
  index: number;
};
export default function StepPanel({ index, name }: Props) {
  const type = useWorkflowStepType(name);

  switch (type) {
    case 'sendEmailTemplateMessage':
    case 'sendMarkdownEmailMessage':
      return <SendEmailMessageActionSection name={name} />;
    case 'sleep':
      return <SleepSection index={index} name={name} />;
    default:
      return null;
  }
}
